import React from 'react';

import { Box, Link } from '@amzn/awsui-components-react-v3';

import { WithExceptions } from '../ExceptionsModal/WithExceptions';
import { REFERENCE_ERROR_CODES, REFERENCE_ERROR_CODES_MAPPING } from './constants';

export const PoNotFound = () => {
  return (
    <Box color="text-status-error">
      <span>{REFERENCE_ERROR_CODES_MAPPING.po_not_found}</span>
    </Box>
  );
};

export const RefrenceNotFound = () => {
  return <Box color="text-status-error">{REFERENCE_ERROR_CODES_MAPPING.reference_not_exists}</Box>;
};

export const ShipmentNotFound = () => {
  return <Box>{REFERENCE_ERROR_CODES_MAPPING.shipment_id_not_found}</Box>;
};

export const PermissionError = () => {
  return (
    <Box color="text-status-error">
      User doesn't have permissions, review and request permission,
      <Link href="https://w.amazon.com/bin/view/AWS_SCM/InventoryManagement/scos-jupiter/scos-unified-receive/access-Issue/">
        Unified Receive Access
      </Link>
    </Box>
  );
};

export const ErrorMessage = ({ code, inputReference }: { code: string; inputReference?: string }) => {
  if (code === REFERENCE_ERROR_CODES.po_not_found) {
    return <PoNotFound />;
  }

  if (code === REFERENCE_ERROR_CODES.OperationNotPermitted || code === REFERENCE_ERROR_CODES.AccessDeniedException) {
    return <PermissionError />;
  }

  if (code === REFERENCE_ERROR_CODES.reference_not_exists) {
    return <RefrenceNotFound />;
  }

  if (code === REFERENCE_ERROR_CODES.shipment_id_not_found || code === REFERENCE_ERROR_CODES.shipment_not_found) {
    return <ShipmentNotFound />;
  }

  return REFERENCE_ERROR_CODES_MAPPING[code] || REFERENCE_ERROR_CODES_MAPPING.network_error;
};

export const ErrorMessages = WithExceptions(ErrorMessage);
